import React, { useState } from "react";
import Button from "components/CustomButton";
import Scrollbar from "react-scrollbars-custom";
import { ReactComponent as Poll } from "assets/img/icons/Create_Poll_Menu.svg";
import TeamPollList from "views/Teams/TeamPoll/TeamPollList.js";
import { Modal } from "react-responsive-modal";
import { ReactComponent as CloseIcon } from "assets/img/icons/cancel.svg";
import { useTeamActionContext } from "store/contexts/teamActionContext";
import "assets/scss/partials/microsoftTeams.scss";

export default () => {
  const [dialog, setDialog] = useState(false);
  const { setShowPollListTeams } = useTeamActionContext();

  const openTodoListDialog = () => {
    setDialog(true);
    setShowPollListTeams(true);
  };

  return (
    <>
      <Button
        buttonClass="invite-btn text-center microsoftTeamTodoListButton"
        onClick={openTodoListDialog}
      >
        <Poll style={{ fill: "white", width: "24px" }} />
        Poll List
      </Button>
      <Modal
        open={dialog}
        closeOnOverlayClick={false}
        onClose={() => setDialog(false)}
        showCloseIcon={false}
        center={true}
        classNames={{ modal: "microsoftTeamUserPollListDetail" }}
        closeOnEsc={false}
      >
        <div className="microsoftTeamsDialogHeader todoListMicrosoftTeamButton">
          {" "}
          Poll List
          <div className="closeMicrosoftTeamsDialog">
            <CloseIcon onClick={() => setDialog(false)} className="cursor" />
          </div>
        </div>
        <div className="pollListContent">
          <Scrollbar style={{ height: "calc(100vh - 100px)" }}>
            <div>
              <div>
                <TeamPollList />
              </div>
            </div>
          </Scrollbar>
        </div>
      </Modal>
    </>
  );
};
